import { render, staticRenderFns } from "./OrganisationIdentityAccess.vue?vue&type=template&id=14eb68c7&scoped=true&"
import script from "./OrganisationIdentityAccess.vue?vue&type=script&lang=js&"
export * from "./OrganisationIdentityAccess.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationIdentityAccess.vue?vue&type=style&index=0&id=14eb68c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb68c7",
  null
  
)

export default component.exports